module.exports = __webpack_public_path__ + "img/theme-title3.cee1e3eb.png";